(function(){
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-pi-qty]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var selector = btn.closest('.pi-qty-selector');
    if (!selector) return;

    var form = selector.closest('form');
    if (!form) return;

    var input = form.querySelector('input[name="quantity"]');
    var display = selector.querySelector('[data-pi-qty-display]');
    if (!input || !display) return;

    var current = parseInt(input.value, 10) || 1;
    var max = parseInt(selector.getAttribute('data-pi-qty-max'), 10) || 15;
    var action = btn.getAttribute('data-pi-qty');

    if (action === 'plus' && current < max) {
      current += 1;
    } else if (action === 'minus' && current > 1) {
      current -= 1;
    }

    input.value = current;
    display.textContent = current;

    var minusBtn = selector.querySelector('[data-pi-qty="minus"]');
    var plusBtn = selector.querySelector('[data-pi-qty="plus"]');

    if (minusBtn) {
      if (current <= 1) {
        minusBtn.setAttribute('disabled', '');
      } else {
        minusBtn.removeAttribute('disabled');
      }
    }

    if (plusBtn) {
      if (current >= max) {
        plusBtn.setAttribute('disabled', '');
      } else {
        plusBtn.removeAttribute('disabled');
      }
    }
  }, true);
})();
